<script setup lang="ts">

import {timeAgo, time} from '../../helpers';
import EasySpeech from 'easy-speech'



const localePath = useLocalePath();
const {locale} = useI18n();
const {params: {slug}, query} = useRoute();

const checkIsPreview = (): boolean => {
    if (query && query.slug && query.slug.length > 0 && query.secret && query.secret.length > 0 && query.type === 'article') {
        return true;
    }

    return false;
}
const loadArticleData = async (): Promise<any> => {

    return await $fetch(`/api/strapi/article`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...checkIsPreview() ? {
                preview: true,
                previewSecret: query.secret,
                slug: query.slug,
            } : {
                preview: false,
                previewSecret: null,
                slug,
                locale: locale.value,
            },
        })
    });
}

const updateFavourite = async (): Promise<any> => {

    return await $fetch(`/api/strapi/article`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
                preview: false,
                previewSecret: null,
                slug,
                locale: locale.value,
                favourite: isFavourite.value
            }
        )
    });

}

const articleData = ref({} as any);
// Load article
articleData.value = await loadArticleData()


const title = ref(articleData.value.article.title);
const ogImage = ref(articleData.value.article.cover[0].url);

useSeoMeta({
	title: title.value,
	ogTitle: title.value,
	description: articleData.value.article.excerpt,
	ogDescription: articleData.value.article.excerpt,
	ogImage: ogImage.value,
	twitterCard: 'summary_large_image',
	twitterSite: '@Political_Room',
})

const breadcrumbJsonLd = {
	"@context": "https://schema.org",
	"@type": "BreadcrumbList",
	"itemListElement": [
		{
			"@type": "ListItem",
			"position": 1,
			"name": "Inicio",
			"item": "https://thepoliticalroom.com/"
		},
		{
			"@type": "ListItem",
			"position": 2,
			"name": "Blog",
			"item": "https://thepoliticalroom.com/blog"
		},
		{
			"@type": "ListItem",
			"position": 3,
			"name": title.value,
			"item": "https://thepoliticalroom.com/blog/" + articleData.value.article.slug
		}
	]
}

const newsArticleJsonLd = {
	"@context": "https://schema.org",
	"@type": "NewsArticle",
	"headline": title.value,
	"description": articleData.value.article.excerpt,
	"datePublished": articleData.value.article.publishedAt,
	"author": {
		"@type": "Person",
		"name": articleData.value.article.author.firstname,
		"url": "https://thepoliticalroom.com/colaborador/" + articleData.value.article.author.id
	},
	"publisher": {
		"@type": "Organization",
		"name": "The Political Room",
		"logo": {
			"@type": "ImageObject",
			"url": "https://thepoliticalroom.com/logo.svg"
		}
	},
	"mainEntityOfPage": {
		"@type": "WebPage",
		"@id": "https://thepoliticalroom.com/blog/" + articleData.value.article.slug
	},
	"image": {
		"@type": "ImageObject",
		"url": ogImage.value,
		"width": 1280,
		"height": 720
	}
}

useHead({
	titleTemplate: '%s - The Political Room',
	bodyAttrs: {
		class: `post-template global-hash-load-more`
	},
	script: [
		{
			id: 'breadcrumb-jsonld',
			type: 'application/ld+json',
			innerHTML: JSON.stringify(breadcrumbJsonLd)
		},
		{
			id: 'news-article-jsonld',
			type: 'application/ld+json',
			innerHTML: JSON.stringify(newsArticleJsonLd)
		}
	],
    link: [
        {
            rel: 'canonical',
            href: articleData.value.article.canonical || "https://thepoliticalroom.com/blog/" + articleData.value.article.slug
        }
    ]
});

const colaboratorData = ref({} as any);
const nextArticleData = ref({} as any);
const prevArticleData = ref({} as any);
const isReady = ref(false);
const post_container = ref(null)
const testPlay = ref(null)
const testPause = ref(null)
const voices = ref([])
const selectedVoice = ref(null)
const isClicked = ref(false);
const onScrollEvent = ref();
const isFavourite = ref(false);
const isUser = ref(false);
const isGeneratingPdf = ref(false)

const readingTime = (text: any) => {
    if (text === undefined) return 0;
    const wpm = 300;
    const words = text.trim().split(/\s+/).length;
    return Math.ceil(words / wpm);
}

/////////////////VOICES/////////////////////////

const getVoicesByBrowser = () => {
    const browser = detectBrowser();

    const availableVoices = window.speechSynthesis.getVoices();
    voices.value = availableVoices.filter(voice => voice.lang === 'es-ES' && voice.name.includes('Google'));
    selectedVoice.value = voices.value[0]; // Seleccionar la primera voz disponible
}


const detectBrowser = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('Chrome') > -1) {
        return 'Chrome';
    } else if (userAgent.indexOf('Firefox') > -1) {
        return 'Firefox';
    } else if (userAgent.indexOf('Safari') > -1) {
        return 'Safari';
    }
    return 'Other';
}

const state = reactive({
    chunks: [],
    currentIndex: 0,
    isPaused: false,
    firstTime: false
});

onMounted(async () => {



	EasySpeech.init({ maxTimeout: 5000, interval: 250 })
		.then(() => console.debug('load complete'))
		.catch(e => console.error(e))
    state.chunks = []
    state.currentIndex = 0
    state.isPaused = false
    state.firstTime = false
    let startTime = Date.now();
    let randomTime = Math.floor(Math.random() * (120000 - 60000 + 1)) + 60000;
    const { article, colaborator, nextArticle, prevArticle, favourite, user }: any = articleData.value
	isUser.value = user
	isFavourite.value = favourite
    articleData.value = article;
    colaboratorData.value = colaborator;
    nextArticleData.value = nextArticle && nextArticle[0];
    prevArticleData.value = prevArticle && prevArticle[0];

    if (article) {

        var d = document, s = d.createElement('script');
        s.src = 'https://thepoliticalroom.disqus.com/embed.js';
        s.setAttribute('data-timestamp', +new Date());
        (d.head || d.body).appendChild(s);

        // Añadimos el widget de twitter
        var e = document, c = e.createElement('script');
        c.src = 'https://platform.twitter.com/widgets.js';
        (e.head || e.body).appendChild(c);

        isReady.value = true;

        // Calculamos el scroll
        onScrollEvent.value = async function onScroll() {
            var targetElement = document.getElementById('badge-read');
            if (targetElement) {
                var rect = targetElement.getBoundingClientRect();

                // Comprobar si el elemento está en la vista
                if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                    const endTime = Date.now();
                    const timeSpent = endTime - startTime;

                    if ((timeSpent > randomTime) && isClicked.value === false) {
                        isClicked.value = true;
                        await badgePoints();
                    }

                }
            }
        }

        // Escuchar el evento de scroll
        window.addEventListener('scroll', onScrollEvent.value);
        const badgePoints = async () => {
            return await $fetch(`/api/strapi/badges/add-badge`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    articleID: articleData.value.id,
                })
            });
        }


		await nextTick();
		cambiarImagenesParalelo();

    }
});

function cambiarImagenesParalelo() {
	const imgs = document.querySelectorAll("#container_test img");
	[...imgs].map(async img => {
        const nuevaSrc = img.src
        img.crossOrigin = 'anonymous';
        img.alt = img.alt || img.nextElementSibling?.textContent.trim().split('.')[0] || 'foto'
		img.src = nuevaSrc + "?timestamp=" + new Date().getTime();
	})
}

function htmlToText(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || "";
}

function speakText(text) {
    const utterance = new SpeechSynthesisUtterance(text);

    window.speechSynthesis.speak(utterance);
}
function speakChunks(index = 0) {
    if (index < state.chunks.length) {
        let utterance = new SpeechSynthesisUtterance(state.chunks[index]);
        utterance.onend = () => speakChunks(index + 1);
        utterance.lang = 'es-ES'
        utterance.voice = selectedVoice.value
        window.speechSynthesis.speak(utterance);
    }
}


function speakLongText(longText: any, chunkSize = 200) {


    while (state.currentIndex < longText.length) {

        let nextChunk: string = longText.slice(state.currentIndex, state.currentIndex + chunkSize);
        let lastPeriodIndex = nextChunk.lastIndexOf('.');


        if (lastPeriodIndex > -1 && state.currentIndex + chunkSize < longText.length) {
            nextChunk = longText.slice(state.currentIndex, state.currentIndex + lastPeriodIndex + 1);
            state.currentIndex += lastPeriodIndex + 1;
        } else {
            state.currentIndex += chunkSize;
        }

        state.chunks.push(nextChunk.trim());
    }
    speakChunks();
}

function detectDevice() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	if (/android/i.test(userAgent)) {
		return "Android";
	}
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return "iOS";
	}
	if (/windows phone/i.test(userAgent)) {
		return "Windows Phone";
	}
	if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
		return "Tablet";
	}
	if (/mobile|android|iphone|ipod|blackberry|opera mini|windows phone/i.test(userAgent)) {
		return "Mobile";
	}

	return "Desktop";
}

function pauseSpeech() {
    state.isPaused = true;
	EasySpeech.pause()
}

async function resumeSpeech() {
    if (state.isPaused) {
        state.isPaused = false;
		EasySpeech.resume()
    }
}


const speak = async () => {
    if (process.client) {
		const btn_listen = document.getElementById('btn_listen')
        if (!state.isPaused || !state.firstTime) {

            if (!state.firstTime) {
                state.firstTime = true

                btn_listen!.style.display = 'none'
                testPause.value.style.display = 'block'
                const cont = []
                for (const i of post_container._value.children) {

                    if (i.nodeName === 'P') {
                        cont.push(i.innerText)
                    }
                }
				let voice = EasySpeech.voices().filter(voice => voice.name === 'Mónica')
				if (detectDevice() === 'Android') {
					const availableVoices = window.speechSynthesis.getVoices();
					selectedVoice.value = availableVoices.filter(voice => voice.name === 'Mónica')[0]
					speakLongText(cont.toString())
					return

				}
				await EasySpeech.speak({
					text: cont.toString(),
					voice: voice[0], // optional, will use a default or fallback
					pitch: 1,
					rate: 0.92,
					volume: 1,
				})

            } else {
				if (detectDevice() === 'Android') {
					state.firstTime = false
					testPlay.value.style.display = 'none'
					testPause.value.style.display = 'none'
					btn_listen!.style.display = 'block'
					EasySpeech.cancel()
					return
				}
                testPlay.value.style.display = 'block'
                testPause.value.style.display = 'none'
                pauseSpeech()
            }

        } else {
            testPlay.value.style.display = 'none'
            testPause.value.style.display = 'block'
            resumeSpeech()
        }
    }
}

function htmlToPdf(title: string, author: string, published: string) {

    if (process.client && isGeneratingPdf.value) {
        import('html2pdf.js').then((html2pdf) => {

			const articleContent = document.getElementById('container_test')
            const titlehtml = `<h3 style="text-align: center">${title}</h3>`
			const lastname = author.lastname ?? ''
            const authorhtml = `<div style="display: flex;justify-content: end">
                                    <i style="font-size: 12px;font-weight: bold">
                                        ${author.firstname  + " " + lastname + " " + time(published)}
                                    </i>
                                </div>`
            const css = `<style>
								.raw-html-embed {
									display: none !important;
								}
                                figure:has(img) {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    flex-direction: column;
                                }

                                p, li {
                                    font-size: 14px !important;
                                    line-height: 1.8;

                                }
                                figcaption span {
                                    display: contents !important;

                                    i {
                                        font-size: 11px !important;
                                        display: contents !important;
                                    }

                                }

                          </style>`
            const htmlContent = titlehtml + css + articleContent!.outerHTML + authorhtml

			const options = {
				margin: [10, 10],
				filename: `${title}.pdf`,
				image: { type: 'webp', quality: 0.8 },
				html2canvas: {
					dpi: 192,
					letterRendering: true,
					useCORS: true,
					scale: 2,
				},
				jsPDF: {
					orientation: "portrait",
					unit: "mm",
					format: "a4",
					putOnlyUsedFonts: true,
					compressPDF: true,
				},
				pagebreak: { mode: ["avoid-all", "css", "legacy"] },

			};

			html2pdf.default().from(htmlContent).set(options).save().then(() => {
				setTimeout(() => {isGeneratingPdf.value = false}, 0)
			});
        });
    }
}

const createPdf = () => {
    isGeneratingPdf.value = true
    htmlToPdf(articleData.value.title, articleData.value.author, articleData.value.publishedAt)

}

const addFavorite = async () => {

	isFavourite.value = !isFavourite.value;
	updateFavourite()
}

onUnmounted(() => {

    state.isPaused = false;
    state.chunks = [];
    state.currentIndex = 0;
    state.firstTime = false
	EasySpeech.cancel()
	window.removeEventListener('scroll', onScrollEvent.value);
})

function copyLink() {
    var copyText = document.getElementById("link-value") as HTMLInputElement;

    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText.value);
}

</script>

<style scoped>

#icon_play, #icon_pause {
    display: none;
}

.post-share a {
    /*padding-left: 0;*/
}

.disqus {
    margin-bottom: 100px !important;
}

.post-wrap {
    padding-bottom: 30px !important;
}

.members-signup:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

</style>

<template>
    <div>

        <div v-if="isReady && articleData">
            <Head>
                <Title>The political room</Title>

                <Html :lang="locale"/>
            </Head>
            <article>
                <div class="section-featured is-featured-image">
                    <div class="featured-image"
                         :style="{ backgroundImage: `url(${articleData.cover && articleData.cover[0].url})` }"></div>
                    <div class="featured-wrap flex">
                        <div class="featured-content">
                            <div class="tags-wrap">
                                <span class="featured-label global-tag" v-if="articleData.featured">
                                    <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path
                                        d="M22.9712403,8.05987765 L16.2291373,8.05987765 L12.796794,0.459688839 C12.5516266,-0.153229613 11.4483734,-0.153229613 11.0806223,0.459688839 L7.64827899,8.05987765 L0.906176009,8.05987765 C0.538424938,8.05987765 0.170673866,8.30504503 0.0480901758,8.6727961 C-0.0744935148,9.04054717 0.0480901758,9.40829825 0.293257557,9.65346563 L5.31918887,14.3116459 L3.11268244,22.4021694 C2.99009875,22.7699205 3.11268244,23.1376716 3.48043351,23.382839 C3.72560089,23.6280063 4.21593565,23.6280063 4.46110303,23.5054227 L11.9387082,19.2149935 L19.4163133,23.5054227 C19.538897,23.6280063 19.6614807,23.6280063 19.906648,23.6280063 C20.1518154,23.6280063 20.2743991,23.5054227 20.5195665,23.382839 C20.7647339,23.1376716 20.8873176,22.7699205 20.8873176,22.4021694 L18.6808111,14.3116459 L23.7067424,9.65346563 C23.9519098,9.40829825 24.0744935,9.04054717 23.9519098,8.6727961 C23.7067424,8.30504503 23.3389914,8.05987765 22.9712403,8.05987765 Z"></path></svg>
                                    <span>Destacado</span>
                                </span>
                                <a v-if="articleData.tags" class="post-tag global-tag"
                                   :href="`/buscador/?tag=${tag.id}`" v-for="tag in articleData.tags">{{ tag.name }}</a>
                            </div>
                            <h2 class="white">{{ articleData.title }}</h2>

                            <div class="item-meta white is-primary-tag is-members-label">
                                <span>por </span>
                                <NuxtLink
                                    :to="localePath({ name: 'colaborate-id', params: { id: articleData.author && articleData.author.id } })"
                                    class="author-name white">
                                    {{
                                        (articleData && articleData.author && articleData.author.firstname) + ' ' + (articleData && articleData.author && articleData.author.lastname ? ' ' + articleData.author.lastname : '')
                                    }}
                                </NuxtLink>
                                <div v-if="articleData.other_authors && articleData.other_authors.length > 0"
                                     style="display: inline">
                                    /
                                    <NuxtLink
                                        :to="localePath({ name: 'colaborate-id', params: { id: articleData.other_authors[0].id } })"
                                        class="author-name white">
                                        {{ articleData.other_authors[0].firstname || 'otro autor' }}
                                    </NuxtLink>
                                </div>
                                <br>
                                <time>{{ time(articleData.publishedAt) }}</time>
                                <br>
                                <span class="reading-time">
                                    <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path
                                        d="M10.1907692,24 C4.5625628,24 0,19.4374372 0,13.8092308 C0,8.18102433 4.5625628,3.61846154 10.1907692,3.61846154 C15.8189757,3.61846154 20.3815385,8.18102433 20.3815385,13.8092308 C20.3815385,19.4374372 15.8189757,24 10.1907692,24 Z M10.1907692,22 C14.7144062,22 18.3815385,18.3328677 18.3815385,13.8092308 C18.3815385,9.28559383 14.7144062,5.61846154 10.1907692,5.61846154 C5.6671323,5.61846154 2,9.28559383 2,13.8092308 C2,18.3328677 5.6671323,22 10.1907692,22 Z"
                                        id="Oval"></path><path
                                        d="M7.53230769,2.32923077 C6.98002294,2.32923077 6.53230769,1.88151552 6.53230769,1.32923077 C6.53230769,0.776946019 6.98002294,0.329230769 7.53230769,0.329230769 L12.9225711,0.329230769 C13.4748559,0.329230769 13.9225711,0.776946019 13.9225711,1.32923077 C13.9225711,1.88151552 13.4748559,2.32923077 12.9225711,2.32923077 L7.53230769,2.32923077 Z"
                                        id="Line-2"></path><path
                                        d="M13.2928932,9.29289322 C13.6834175,8.90236893 14.3165825,8.90236893 14.7071068,9.29289322 C15.0976311,9.68341751 15.0976311,10.3165825 14.7071068,10.7071068 L10.897876,14.5163376 C10.5073517,14.9068618 9.87418674,14.9068618 9.48366245,14.5163376 C9.09313816,14.1258133 9.09313816,13.4926483 9.48366245,13.102124 L13.2928932,9.29289322 Z"
                                        id="Line"></path></svg>
                                    {{ readingTime(articleData.content) }} min tiempo de lectura
                                </span>
                                <br>

                                <div style="display: block">
									<button v-if="isUser" @click="speak"
                                            class="members-signup"
											style="border: none;margin: 20px 0;cursor: pointer;padding: 10px 20px;
                                        min-width: 10rem;display: flex;justify-content: center;
                                        min-height: 36px;align-items: center">
										<span id="btn_listen">Escuchar artículo</span>
										<svg id="icon_play" ref="testPlay" fill="#fff" width="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg>
										<svg id="icon_pause" ref="testPause" fill="#fff" width="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"/></svg>
									</button>
									<button v-if="isUser" id="btn_pdf"  @click="createPdf()"
                                            :disabled="isGeneratingPdf"
                                            class="members-signup"
											style="border: none;margin: 20px 0;cursor: pointer;padding: 10px 20px;
                                        min-width: 10rem;max-width: 10rem;display: flex;justify-content: center;
                                        min-height: 36px;align-items: center">
										<span v-if="!isGeneratingPdf">Imprimir PDF</span>
										<span v-if="isGeneratingPdf" ><MiniSpinner /></span>
									</button>
									<div v-if="isUser">
										<button v-if="isFavourite" @click="addFavorite"
												style="border: 1px solid #3f908a;margin: 20px 0;cursor: pointer;padding: 10px 20px;
												min-width: 10rem;display: flex;justify-content: center;border-radius: 40px;
												min-height: 36px;align-items: center;background-color: transparent">
											<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 16 16" fill="none">
												<path d="M1.24264 8.24264L8 15L14.7574 8.24264C15.553 7.44699 16 6.36786 16 5.24264V5.05234C16 2.8143 14.1857 1 11.9477 1C10.7166 1 9.55233 1.55959 8.78331 2.52086L8 3.5L7.21669 2.52086C6.44767 1.55959 5.28338 1 4.05234 1C1.8143 1 0 2.8143 0 5.05234V5.24264C0 6.36786 0.44699 7.44699 1.24264 8.24264Z" fill="#ff0000"/>
											</svg>

										</button>
										<button v-else @click="addFavorite"
												style="border: 1px solid #3f908a;margin: 20px 0;cursor: pointer;padding: 10px 20px;
												min-width: 10rem;display: flex;justify-content: center;border-radius: 40px;
												min-height: 36px;align-items: center;">
											<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 16 16" fill="none">
												<path d="M1.24264 8.24264L8 15L14.7574 8.24264C15.553 7.44699 16 6.36786 16 5.24264V5.05234C16 2.8143 14.1857 1 11.9477 1C10.7166 1 9.55233 1.55959 8.78331 2.52086L8 3.5L7.21669 2.52086C6.44767 1.55959 5.28338 1 4.05234 1C1.8143 1 0 2.8143 0 5.05234V5.24264C0 6.36786 0.44699 7.44699 1.24264 8.24264Z" fill="#ffb3b3"/>
											</svg>

										</button>
									</div>
								</div>
                                <div class="post-share"
                                     style="width:230px;background-color:#f0f1f0;display: flex;align-items: center;position: relative;bottom: 0px;margin: 16px 0px 0px 0px;padding: 0px 0px 0px 0px;justify-content: space-between;">
                                    <a class="twitter"
                                       :href="'http://twitter.com/share?text=' + articleData.seo.seoTitle + '&url=https://thepoliticalroom.com/blog/' + articleData.slug  + '&hashtags=ThePoliticalRoom'"
                                       onclick="window.open(this.href, '', 'width=700,height=700');return false;">
                                        <svg class="global-svg" role="img" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path>
                                        </svg>
                                    </a>
                                    <div style="display:flex;align-items: center;" class="fb-share-button"
                                         data-href="https://developers.facebook.com/docs/plugins/" data-layout=""
                                         data-size="">
                                        <a class="facebook fb-xfbml-parse-ignore" target="_blank"
                                           href="https://www.facebook.com/sharer/sharer.php?u=https://thepoliticalroom.com&description=your+text+goes+here&amp;src=sdkpreparse">
                                            <svg class="global-svg" role="img" viewBox="0 0 24 24"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"></path>
                                            </svg>
                                        </a>
                                    </div>
                                    <a class="copy" @click="copyLink()" >
                                        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M20.33 13.04h-4.155v4.154h-2.078v-4.155H9.942v-2.077h4.155V6.806h2.078v4.156h4.154v2.077zM8.902 18.58a6.582 6.582 0 0 1 0-13.162c.068 0 .135.007.202.009a8.874 8.874 0 0 0-.001 13.144c-.067 0-.133.009-.2.009zm6.194-15.484a8.876 8.876 0 0 0-3.087.56A8.904 8.904 0 0 0 0 12a8.903 8.903 0 0 0 8.903 8.905 8.893 8.893 0 0 0 3.103-.563 8.854 8.854 0 0 0 3.09.563A8.903 8.903 0 0 0 24 12a8.904 8.904 0 0 0-8.903-8.903z"></path>
                                        </svg>
                                    </a>
                                    <span class="copy-popup">El link ha sido copiado!</span>
                                    <input type="text" :value="'https://thepoliticalroom.com/blog/' + articleData.slug"
                                           id="link-value">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-post wrap">
                    <div id="container_test" class="post-wrap" v-html="articleData.content" ref="post_container"></div>
                    <span id="badge-read"></span>
                    <div id="disqus_thread" class="disqus"></div>
                    <div class="section-post-authors post-authors flex  post-author-single first"
                         v-if="colaboratorData">
                        <div class="author-label">
                            <span>Leer más artículos de este autor</span>
                        </div>
                        <div class="author-wrap flex">
                            <NuxtLink
                                :to="localePath({ name: 'colaborate-id', params: { id: articleData && articleData.author && articleData.author.id } })"
                                class="item-link-overlay"></NuxtLink>
                            <div class="author-profile-image"
                                 :style="{ backgroundImage: `url(${colaboratorData.profile_image_url || (colaboratorData.profile_image && colaboratorData.profile_image.url)  || 'https://secure.gravatar.com/avatar/00de25a32008afbed3a4ca5e2e2c20e5?s=512&d=mm&r=g'})` }"></div>
                            <div class="author-content">
                                <h4 class="is-bio no-cover-image">
                                    <NuxtLink
                                        :to="localePath({ name: 'colaborate-id', params: { id: articleData && articleData.author && articleData.author.id } })">
                                        {{
                                            (articleData && articleData.author && articleData.author.firstname) + ' ' + (articleData && articleData.author && articleData.author.lastname ? ' ' + articleData.author.lastname : '')
                                        }}
                                    </NuxtLink>
                                </h4>
                                <p>{{ colaboratorData.bio }}</p>
                            </div>
                        </div>
                        <div>

                            <form action="https://www.paypal.com/donate" method="post" target="_top">
                                <input type="hidden" name="hosted_button_id" value="3UAL2ELFW9DDG">
                                <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif"
                                       border="0" name="submit" title="PayPal - The safer, easier way to pay online!"
                                       alt="Donate with PayPal button">
                                <img alt="" border="0" src="https://www.paypal.com/en_ES/i/scr/pixel.gif" width="1"
                                     height="1">
                            </form>
                        </div>

                    </div>
                    <div class="post-meta">
                        <div class="post-share">
                            <a class="twitter"
                               :href="'http://twitter.com/share?text=' + articleData.seo.seoTitle + '&url=https://thepoliticalroom.com/blog/' + articleData.slug  + '&hashtags=ThePoliticalRoom'"
                               onclick="window.open(this.href, '', 'width=700,height=700');return false;">
                                <svg class="global-svg" role="img" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path>
                                </svg>
                            </a>
                            <div style="display:flex;align-items: center;" class="fb-share-button"
                                 data-href="https://developers.facebook.com/docs/plugins/" data-layout="" data-size="">
                                <a class="facebook fb-xfbml-parse-ignore" target="_blank"
                                   href="https://www.facebook.com/sharer/sharer.php?u=https://thepoliticalroom.com&description=your+text+goes+here&amp;src=sdkpreparse">
                                    <svg class="global-svg" role="img" viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"></path>
                                    </svg>
                                </a>
                            </div>
                            <a class="copy" @click="copyLink()">
                                <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M20.33 13.04h-4.155v4.154h-2.078v-4.155H9.942v-2.077h4.155V6.806h2.078v4.156h4.154v2.077zM8.902 18.58a6.582 6.582 0 0 1 0-13.162c.068 0 .135.007.202.009a8.874 8.874 0 0 0-.001 13.144c-.067 0-.133.009-.2.009zm6.194-15.484a8.876 8.876 0 0 0-3.087.56A8.904 8.904 0 0 0 0 12a8.903 8.903 0 0 0 8.903 8.905 8.893 8.893 0 0 0 3.103-.563 8.854 8.854 0 0 0 3.09.563A8.903 8.903 0 0 0 24 12a8.904 8.904 0 0 0-8.903-8.903z"></path>
                                </svg>
                            </a>
                            <span class="copy-popup">El link ha sido copiado!</span>
                            <input type="text" :value="'https://thepoliticalroom.com/blog/' + articleData.slug"
                                   id="link-value">
                        </div>
                    </div>
                </div>
            </article>
            <aside class="section-prev-next">
                <div class="prev-next-wrap">

                    <a v-if="prevArticleData" :href="'/blog/' + prevArticleData.slug"
                       class="prev-post post tag-politica tag-turquia tag-erdogan tag-deriva-autoritaria tag-islam tag-estado-islamico tag-fundamentalismo-islamico tag-democracia tag-separacion-de-poderes tag-oriente-medio tag-comunidad-islamica tag-mustafa-kemal tag-kemalismo tag-occidente tag-union-europea tag-proceso-de-adhesion tag-fracaso tag-perdida-de-influencia tag-golpe-de-estado tag-diyanet tag-lideres-religiosos tag-cambio-de-rumbo featured is-image">
                        <div class="prev-next-image"
                             :style="{ 'background-image': `url(${prevArticleData.cover && prevArticleData.cover[0].url})` }"></div>
                        <section class="prev-next-title">
                            <h5>Artículos recientes</h5>
                            <h3>{{ prevArticleData.title }}</h3>
                        </section>
                    </a>
                    <a v-if="nextArticleData" :href="'/blog/' + nextArticleData.slug"
                       class="next-post post tag-politica tag-turquia tag-erdogan tag-union-europea tag-eeuu tag-occidente tag-inflacion tag-devaluacion-de-la-moneda tag-mercado-financiero tag-crisis-economica tag-rusia tag-oriente-medio tag-china tag-relaciones-internacionales tag-acuerdo-comercial featured is-image">
                        <div class="prev-next-image"
                             :style="{ 'background-image': `url(${nextArticleData.cover && nextArticleData.cover[0].url})` }"></div>
                        <section class="prev-next-title">
                            <h5>Artículos antiguos</h5>
                            <h3>{{ nextArticleData.title }}</h3>
                        </section>
                    </a>
                </div>
            </aside>
            <div id="fb-root"></div>
        </div>
        <div v-else class="spinner">
            <Spinner/>
        </div>
    </div>
</template>



<style>
.post-wrap img {
    width: 100% !important;
    margin: 0 auto !important;
}

.raw-html-embed iframe {
    height: 650px;
}

</style>
